import React from 'react';
import { Calendar, Clock } from 'lucide-react';

const HolidayItem = ({ holiday }) => (
  <div className="flex items-center space-x-3 py-2">
    <div className="bg-orange-100 p-1.5 rounded-full">
      <Calendar className="w-4 h-4 text-green-600" />
    </div>
    <span className="text-gray-700">{holiday}</span>
  </div>
);

const HolidaysAndPTO = () => {
  const holidays = [
    "New Year's Day",
    "Memorial Day",
    "Independence Day",
    "Labor Day",
    "Thanksgiving Day",
    "Christmas Day"
  ];

  return (
    <div className="min-h-screen bg-green-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Holiday Pay Eligibility Section */}
        <div className="bg-white rounded-lg shadow-lg overflow-hidden mb-8 border-b-4 border-orange-500">
          <div className="p-6">
            <h2 className="text-2xl font-bold text-green-800 mb-4">Holiday Pay Eligibility</h2>
            <p className="text-gray-600 leading-relaxed">
              At SBG, full-time contract employees become eligible for holiday pay after completing 1000 work hours, 
              approximately six months of service. This policy reflects our commitment to valuing and rewarding 
              the dedication and contributions of our employees. We believe recognizing our staff members' hard 
              work and commitment is essential to fostering a positive and inclusive work environment. By providing 
              holiday pay eligibility after this period, we aim to show our appreciation for the efforts of our 
              contract full-time employees and enhance their overall work experience at SBG.
            </p>
          </div>
        </div>

        {/* Holiday Schedule Section */}
        <div className="bg-white rounded-lg shadow-lg overflow-hidden mb-8 border-b-4 border-orange-500">
          <div className="p-6">
            <h2 className="text-2xl font-bold text-green-800 mb-4">SBG Holiday Schedule</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {holidays.map((holiday, index) => (
                <HolidayItem key={index} holiday={holiday} />
              ))}
            </div>
          </div>
        </div>

        {/* Paid Sick Time Section */}
        <div className="bg-white rounded-lg shadow-lg overflow-hidden border-b-4 border-orange-500">
          <div className="p-6">
            <h2 className="text-2xl font-bold text-green-800 mb-4">Paid Sick Time</h2>
            <div className="space-y-6">
              <div className="bg-orange-50 border-l-4 border-orange-500 p-4">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="bg-orange-100 p-1.5 rounded-full">
                      <Clock className="h-4 w-4 text-green-600" />
                    </div>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm text-green-700">
                      Employees can accrue and use up to 40 hours in a calendar year.
                      Paid Sick Time is accrued at one (1) hour for every 30 hours worked.
                    </p>
                  </div>
                </div>
              </div>

              <p className="text-gray-600 leading-relaxed">
                According to the ARIZONA FAIR WAGES AND HEALTHY FAMILIES ACT, Earned Paid Sick Time can be used for 
                the following reasons:
              </p>

              <ul className="list-disc pl-6 text-gray-600 space-y-2 marker:text-orange-500">
                <li>Medical care for mental or physical illness, injury, or health conditions</li>
                <li>A public health emergency declared by the state</li>
                <li>Absence due to domestic violence, sexual violence, abuse, or stalking</li>
              </ul>

              <p className="text-gray-600 leading-relaxed">
                Employees can use paid sick time for themselves or to take care of their family members. 
                Documentation is necessary for three or more consecutive days of absence. For more information 
                on this law, please visit <a href="http://www.azica.gov" className="text-orange-600 hover:text-orange-700 hover:underline" target="_blank" rel="noopener noreferrer">www.azica.gov</a>.
              </p>

              <div className="bg-white border-l-4 border-orange-500 p-4 shadow-md">
                <p className="text-gray-700">
                  You can check your most recent paystub for the time accrued and used hours. Time is indicated 
                  in hours and minutes. The employees are responsible for promptly informing the department 
                  supervisor and Scott Business Group in case of absence due to one of the above reasons.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HolidaysAndPTO;
